import IAction from '../interfaces/action';
import IActionCreators from '../interfaces/actionCreators';

export const actions = {
    setNoContentMessage: 'app/bookmarks/root/setnocontent',
    setNewCategoryName: 'app/bookmarks/category/newname',
    setEditedCategoryName: 'app/bookmarks/category/editedname',
    setEditedBookmarkName: 'app/bookmarks/editedname',
    deleteBookmark: 'app/bookmarks/listitem/delete',
    addBookmark: 'app/bookmarks/listitem/add',
    addCategory: 'app/categories/add',
    populateBookmarks: 'app/bookmarks/setbookmarks',
    populateCategories: 'app/categories/setcategories',
    setActiveBookmarkerTab: 'app/bookmarks/categories/settab',
    setSelectedCategoryId: 'app/bookmarks/list/selectedcategoryid',
    setSelectedBookmarkId: 'app/bookmarks/list/selectedbookmarkid',
    toggleCreateModal: 'app/bookmarks/modals/create',
    toggleEditModal: 'app/bookmarks/modals/edit',
    toggleTooltip: 'app/bookmarks/modals/tooltip',
    toggleCategorizeModal: 'app/bookmarks/modals/categorize',
    toggleToastBar: 'app/toastbar/toggle',
    setToastBarMessage: 'app/toastbar/set/message',
    setToastBarType: 'app/toastbar/set/type',
    setDisplayCategorizeModalAfterCreateModal: 'app/bookmarks/displayCategorizeModalAfterCreateModal',
}

export const actionCreators: IActionCreators = {
    populateBookmarks: (bookmarks: any[]): IAction => {
        return { type: actions.populateBookmarks, payload: bookmarks };
    },
    populateCategories: (categories: any[]): IAction => {
        return { type: actions.populateCategories, payload: categories };
    },
    setNoContentMessage: (message) => {
        return { type: actions.setNoContentMessage, payload: message };
    },
    deleteBookmark: (pageId) => {
        return { type: actions.deleteBookmark, payload: pageId };
    },
    addBookmark: (bookmark) => {
        return { type: actions.addBookmark, payload: bookmark };
    },
    addCategory: (category) => {
        return { type: actions.addCategory, payload: category };
    },
    setActiveBookmarkerTab: (tabName) => {
        return { type: actions.setActiveBookmarkerTab, payload: tabName };
    },
    setSelectedCategoryId: (categoryId) => {
        return { type: actions.setSelectedCategoryId, payload: categoryId };
    },
    setSelectedBookmarkId: (bookmarkId) => {
        return { type: actions.setSelectedBookmarkId, payload: bookmarkId };
    },
    toggleEditModal: () => {
        return { type: actions.toggleEditModal, payload: null };
    },
    toggleCreateModal: () => {
        return { type: actions.toggleCreateModal, payload: null };
    },
    toggleTooltip: () => {
        return { type: actions.toggleTooltip, payload: null };
    },
    toggleCategorizeModal: () => {
        return { type: actions.toggleCategorizeModal, payload: null };
    },
    toggleToastBar: () => {
        return { type: actions.toggleToastBar, payload: null };
    },
    setNewCategoryName: (name) => {
        return { type: actions.setNewCategoryName, payload: name };
    },
    setEditedCategoryName: (name) => {
        return { type: actions.setEditedCategoryName, payload: name };
    },
    setEditedBookmarkName: (name) => {
        return { type: actions.setEditedBookmarkName, payload: name };
    },
    setToastBarMessage: (msg) => {
        return { type: actions.setToastBarMessage, payload: msg };
    },
    setToastBarType: (type: 'info' | 'warn' | 'success') => {
        return { type: actions.setToastBarType, payload: type };
    },
    setDisplayCategorizeModalAfterCreateModal: (bool) => {
        return { type: actions.setDisplayCategorizeModalAfterCreateModal, payload: bool };
    }
}